"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var abs_csv_export_1 = __importDefault(require("./abs_csv_export"));
var application_details_object_1 = __importDefault(require("../../../common/src/utils/sales_force/application_details_object"));
var SalesForceApplicationDetailsExport = /** @class */ (function (_super) {
    __extends(SalesForceApplicationDetailsExport, _super);
    function SalesForceApplicationDetailsExport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SalesForceApplicationDetailsExport.prototype.getCsvData = function (contractDocument, salesForceInfo) {
        return application_details_object_1.default.create(contractDocument, salesForceInfo);
    };
    SalesForceApplicationDetailsExport.prototype.getFileName = function () {
        return 'ApplicationDetails.csv';
    };
    return SalesForceApplicationDetailsExport;
}(abs_csv_export_1.default));
exports.default = SalesForceApplicationDetailsExport;



//////////////////
// WEBPACK FOOTER
// ./src/utils/sales_force/application_details_export.ts
// module id = ZKR2
// module chunks = 1